import React, {useEffect} from 'react';
import Lottie from 'react-lottie';
import MailAnimation from '../../../animations/envelope-mail-send-outline.json';
import {gtag4} from '../../../utilities/analytics/tracking';
import ThemedLottie from '../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';
export default function LeadSuccess(props) {
  useEffect(() => {
    gtag4({event: 'lead_submission', lead_type: props.lead_type, form_list: props.form_list ? props.form_list : ''}); //Google analytic
  });
  if (props.slaColor) {
    document.documentElement.style.setProperty('--extendedlead-sla-color', `${props.slaColor}`);
  }
  return (
    <div className='lead-success container mt-5'>
      <div className='row'>
        <div className='col-12'>
          <div className='success-image-wrapper'>
            {/* <Lottie options={{animationData: MailAnimation, loop: false}} width={200} height={200} /> */}
            <ThemedLottie animationData={MailAnimation} color={ThemeColorEnum.PRIMARY} width={200} height={200} loop={false} />
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <h1>{props.title}</h1>
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <h2 className='subtitle'>{props.subtitle}</h2>
        </div>
      </div>
      {props.sla != null && (
        <div className='row pt-4'>
          <div className='col-12'>
            {props.sla && <div className='col-12 sla-text' > זמן משוער לטיפול הינו {props.sla} ימי עבודה </div>}
            <div className='col-12 follow-up-text' > מספר הפניה: {props.ticketNumber} </div>
          </div>
        </div>
      )}
    </div>
  );
}
